<template>
    <div class="bread">
        <template v-if="englishDoc">
            <!-- 英文OCR单证 -->
            <h1 ref="index">
                <router-link to="/dashboard/endoc">单证识别</router-link>
                <span></span>
            </h1>
            <!-- <h1 ref="art">
                <router-link to="/dashboard/endoc/artificial">人工处理</router-link>
                <span></span>
            </h1> -->
        </template>
        <template v-else>
            <!-- 中英文OCR单证 -->
            <h1 ref="index">
                <router-link to="/dashboard/cedoc">单证识别</router-link>
                <span></span>
            </h1>
            <!-- <h1 ref="art">
                <router-link to="/dashboard/cedoc/artificial">人工处理</router-link>
                <span></span>
            </h1> -->
        </template>
    </div>
</template>
<script>
export default {
    name: 'bread',
    props: {},
    data() {
        return {
            englishDoc: false
        }
    },
    computed: {},
    components: {},
    watch: {
        $route(to, from) {
            if (to.path.includes('endoc')) {
                this.englishDoc = true;
            } else {
                this.englishDoc = false;
            }
        }
    },
    mounted() {

        if (this.$route.path.includes('endoc') === true) {
            this.englishDoc = true;
        } else {
            this.englishDoc = false;
        }

        if (this.$route.name === 'endoc-docsindex') {
            if(this.$refs && this.$refs.index){
                this.$refs.index.classList.add('active');
            }
            if(this.$refs && this.$refs.art){
                this.$refs.art.classList.remove('active');
            }
        } else if (this.$route.name === 'endoc-artificial') {
            if(this.$refs && this.$refs.index){
                this.$refs.index.classList.remove('active');
            }
            if(this.$refs && this.$refs.art){
                this.$refs.art.classList.add('active');
            }
        } else if (this.$route.name === 'cedoc-docsindex') {
            if(this.$refs && this.$refs.index){
                this.$refs.index.classList.add('active');
            }
            if(this.$refs && this.$refs.art){
                this.$refs.art.classList.remove('active');
            }
        } else {
            if(this.$refs && this.$refs.art){
                this.$refs.art.classList.remove('active');
                this.$refs.art.classList.add('active');
            }
            
        }

    },
    destroyed() {},
    methods: {

    }
};
</script>
<style>
</style>